import Marquee from "react-fast-marquee";
import { useContent } from "@/lib/content";

const StarIcon = ({ color }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true" style={{ color }} data-testid="marquee-star-icon">
    <path
      d="M12 2v20M2 12h20M4.9 4.9l14.2 14.2M19.1 4.9L4.9 19.1"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
    />
  </svg>
);

export const EditorialMarquee = () => {
  const { marquee, colors } = useContent();
  return (
  <div className="border-y border-champagne/70 bg-ivory py-8 md:py-10" data-testid="editorial-marquee">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {marquee.words.map((w) => (
        <span key={w} className="flex items-center">
          <span className="font-serif italic text-3xl md:text-5xl font-light text-burgundy/80 px-8 md:px-14">{w}</span>
          <StarIcon color={colors.ribbonStar} />
        </span>
      ))}
    </Marquee>
  </div>
  );
};
